export type MenteeHeardAboutMentorshipValues =
  | 'FRIEND'
  | 'NEWSLETTER'
  | 'SOCIAL_NETWORKS'
  | 'APPLICATION'
  | 'ESTABLISHMENT'
  | 'TUTOR'
  | 'PRESENTATION'
  | 'PUBLIC_SPACE'
  | 'WEB'
  | 'FORGOT'
  | 'OTHER';

export const menteeHeardAboutMentorships: MenteeHeardAboutMentorshipValues[] = [
  'FRIEND',
  'NEWSLETTER',
  'SOCIAL_NETWORKS',
  'APPLICATION',
  'ESTABLISHMENT',
  'TUTOR',
  'PRESENTATION',
  'PUBLIC_SPACE',
  'WEB',
  'FORGOT',
  'OTHER',
];

enum MENTEE_HEARD_ABOUT_MENTORSHIP {
  FRIEND = "Une connaissance m'en a parlé",
  NEWSLETTER = "J'ai reçu une newsletter de l'Institut de l'Engagement",
  SOCIAL_NETWORKS = "J'ai vu une publication sur les réseaux sociaux",
  APPLICATION = "Lors de ma candidature pour être lauréat de l'Institut de l'Engagement",
  ESTABLISHMENT = "Mon établissement de formation m'en a parlé",
  TUTOR = "Mon organisme d'accueil / mon tuteur m'en a parlé",
  PRESENTATION = "J'ai assisté à une réunion de présentation",
  PUBLIC_SPACE = "J'ai vu un affichage dans l'espace public",
  WEB = "J'ai fait des recherches sur internet",
  FORGOT = 'Je ne me souviens plus',
  OTHER = 'Autre',
}
export default MENTEE_HEARD_ABOUT_MENTORSHIP;
